// Vocabulary: readers see this feature as "owner reviews"; code, routes, DealHunt paths and
// analytics events keep the historical "owner note" name on purpose — do not rename them.

import { useOwnerSurfaceTrack } from 'lib/owner-notes/analytics'
import { FOLLOW_COPY, type Follows } from 'lib/owner-notes/follows'
import styles from './FollowButton.module.css'

/** Follow / Following for one product (`docs/product-follow.md`), on the compare columns and the
 *  product hub. `follows` is the page's one `useFollows()`, so N buttons share one read. */
const FollowButton: React.VFC<{ id: string; follows: Follows; location: 'compare' | 'hub' }> = ({
  id,
  follows,
  location,
}) => {
  const surface = useOwnerSurfaceTrack()
  const on = follows.isOn(id)
  const error = follows.error?.nodeId === id ? follows.error.message : null
  return (
    <div className={styles.follow}>
      <button
        type="button"
        className={styles.button}
        aria-pressed={on}
        disabled={follows.busy === id}
        onClick={() => {
          surface('follow_toggle', {
            location,
            action: on ? 'unfollow' : 'follow',
            target_product_id: id,
          })
          follows.toggle(id)
        }}
      >
        {on ? FOLLOW_COPY.on : FOLLOW_COPY.off}
      </button>
      <span className={styles.note}>{on ? FOLLOW_COPY.onNote : FOLLOW_COPY.offNote}</span>
      {error && (
        <span className={styles.error} role="alert">
          {error}
        </span>
      )}
    </div>
  )
}

export default FollowButton
